import 'twin.macro'

import CircularLoader from 'assets/icons/circular-loader.svg?component'
import { FC } from 'react'
import { TwStyle } from 'twin.macro'

const Loader: any = ({ twStyle }: { twStyle?: TwStyle }): JSX.Element => {
  return <CircularLoader css={twStyle} />
}

export default Loader
